import { Dispatch, SetStateAction } from "react";
import { Group } from "../../admin/types";
import { AccountManagersResponse, ClientAMResponse, FormData, ResponseData } from "./type";
import { isAdmin, isClient, isExpert, isSuperAdmin } from "../../../utils/role";
import { FormatToLVCommon } from "../../../common/formatData";
import { RequestServer } from "../../../utils/services";
import { APIRoutes } from "../../../constants";
import { labelValueType ,labelValueStringType} from "../../client/all-clients/types";
import { Filters } from "../types";
import { CLIENT_TYPES } from "../../../constants/project.constants";
import { useOptionsFetch } from "../../../utils/hooks/useOptionsFetch";

export const getFormOptions = async (
    groupData: Group[] | null,
    setFormOptions: Dispatch<SetStateAction<FormData>>
) => {
    let group: any[] = [];
    let am: any[] = [];
    let client: any[] = [];
    let client_am: any[] = [];

    try {
        if (isSuperAdmin()) {

            // GROUPS ------------------ //

            if (groupData) {
                group = FormatToLVCommon(groupData, "label", "id");
            } else {
                const all_groups = await getGroups();
                group = FormatToLVCommon<Group, "label", "id">(all_groups, "label", "id");
            }

            // ------------------------ //

            // AM --------------------- //

            am = await getAMs();

            // ------------------------ //
        }

        if (isAdmin()) {
            const admin_groups = await getGroups();
            group = FormatToLVCommon<Group, "label", "id">(admin_groups, "label", "id");
        }


        if (isClient()) {
            client_am = await getClientAMs();
        }

        setFormOptions((prev) => ({
            ...prev,
            client: client,
            am: am,
            group: group,
            filtered_am: am,
            filtered_client: client,
            client_filter_am: client_am
        }))
    } catch (err) {
        console.error(err);
    }
}

export const getGroups = async () => {
    try {
        const response = await RequestServer(APIRoutes.groupsMappedToMe, "GET");
        return response.data || [];
    } catch (err) {
        console.error(err);
        return [];
    }
}

export const getAMs = async (fk_group?: string) => {
    try {

        // avoid calling the api if fk_group is not given in case of admin
        if (isAdmin() && !fk_group) {
            return [];
        }

        const url = APIRoutes.getAccountManager + (fk_group ? "?in___fk_group=" + fk_group : "");

        const response: AccountManagersResponse = await RequestServer(url, "GET");

        if (response.success) {
            return response.data.map(am => ({
                label: am.account_manager_value.name,
                value: am.account_manager_value.id
            }))
        } else {
            return [];
        }

    } catch (err) {
        console.error(err);
        return [];
    }
}

export const getClientAMs = async () => {
    try {
        const url = APIRoutes.getCallsAM;

        const response: ClientAMResponse = await RequestServer(url, "GET");

        if (response.success) {
            return response.data.account_managers.map(am => ({
                label: am.name,
                value: am.id
            }))
        } else {
            return [];
        }
    } catch (err) {
        console.error(err);
        return [];
    }
}


export const getClientContacts = async (clients: string | null, setClientContacts: Dispatch<SetStateAction<labelValueType[] | null>>) => {

    if (!clients) {
        setClientContacts([]);
        return;
    }

    try {
        const response: ResponseData = await RequestServer(APIRoutes.clientContactUrl + "?in___id=" + clients, "GET");
        
        if (response.success) {
            setClientContacts(() => FormatToLVCommon(response.data,"name","id"))
        }else{
            setClientContacts([]);
        }
    } catch (err) {
        setClientContacts([]);
        console.error(err);
    }
}

export const getClientsById = async (clients: string | null, setClients: Dispatch<SetStateAction<labelValueStringType[] | null>>) => {

    if (!clients) {
        setClients([]);
        return;
    }
    try {
        const response: ResponseData = await RequestServer(APIRoutes.clients + "?in___id=" + clients, "GET");
        if (response?.success) {
            setClients(response?.data?.map((client: any) => ({
                label: client.name,
                value: client.id
            })))
        }else{
            setClients([]);
        }

    } catch (err) {
        setClients([]);
        console.error(err);
    }
}

export const getClientTypes = async (clientTypes: string | null, setClientTypes: Dispatch<SetStateAction<labelValueStringType[] | null>>) => {
    if (!clientTypes) {
        setClientTypes([]);
        return;
    }

    try {
        const result:labelValueStringType[] = Object.keys(CLIENT_TYPES).map((type:string, index:number) => ({
            label: CLIENT_TYPES[type as keyof typeof CLIENT_TYPES],
            value: CLIENT_TYPES[type as keyof typeof CLIENT_TYPES]
        }))
        const selectedClientTypes = result.filter(type => clientTypes.includes(type.value));
        setClientTypes(selectedClientTypes);
    } catch (err) {
        setClientTypes([]);
        console.error(err);
    }
}

export const handleSubmit = (newChecked: number[], setFilters: React.Dispatch<React.SetStateAction<Filters>>) => {
    const isClientOrExpert = isClient() || isExpert();
        const status: string[] = [];

        if (isClientOrExpert) {
            for (let idx of newChecked) {
                switch (idx) {
                    case 0: {
                        status.push("Logged")
                        break;
                    }
                    case 1: {
                        status.push("Pending,Scheduled")
                        break;
                    }
                    default: break;
                }
            }

        } else {
            for (let idx of newChecked) {
                switch (idx) {
                    case 0: {
                        status.push("Logged")
                        break;
                    }
                    case 1: {
                        status.push("Pending")
                        break;
                    }
                    case 2: {
                        status.push("Scheduled")
                        break;
                    }
                    case 3: {
                        status.push("Canceled")
                        break;
                    }
                }
            }
        }

        setFilters((prev) => ({
            ...prev,
            isFilterChange: true,
            isFilterApplied: true,
            sidebarFilters: {
                ...prev.sidebarFilters,
                status: status.join(",")
            }
        }))
    }